export default class ClaimantDetails {
	constructor() {
		this.claimantName = null;
		this.dateOfDeath = null;
		this.executor = null;
		this.authorisedToAct = null;
		this.capacityId = null;
	}
}
